import { DragIndicator, Edit, AccessTime } from '@mui/icons-material';
import ImageIcon from '@mui/icons-material/Image';
import { Chip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Card, CardContent, IconButton, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import find from "lodash/find";
import get from "lodash/get";
import { useCanView } from "../../config/hook/UserPermissions";
import Alert from "../../components/form/Alert";

const DragAndDropComponent = ({ points, newPoints = [], callBackPoint, text,  onEditTime, onEditStatus, moveItem, handleDelete, onEditImage, stateRoute }) => {
  const [deliveryPoints, setDeliveryPoints] = useState(newPoints);
  const [__] = useTranslation("route");
  const deliveryPointStatus = __(`deliveryPointStatus`, { returnObjects: true });
  const canView = useCanView();
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });

  // Efecto para mapear los datos de temporalDP al estado deliveryPoints
  useEffect(() => {
    if (points) {
      setDeliveryPoints(points);
      callBackPoint(points)
    }
  }, [points]);

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const DraggableItem = ({ item, index, onDelete }) => {
    const [{ isDragging }, dragRef] = useDrag({
      type: 'deliveryPoint',
      item: { index },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      canDrag: stateRoute !== 7 && stateRoute !== 5 && canView("TRANSACCIONES/RUTAS/PUNTOS DE ENTREGA", "update"),
    });

    const [, dropRef] = useDrop({
      accept: 'deliveryPoint',
      hover: (draggedItem) => {
        if (draggedItem.index !== index) {
          moveItem(draggedItem.index, index);
          draggedItem.index = index;
        }
      },
    });

    const getStatusColor = (statusId) => {
      return statusId === 3 ? 'success' : statusId === 4 ? 'error' : 'default';
    };

    const statusLabel = get(find(deliveryPointStatus, ({ value }) => value === item.statusId), "label");
    const statusColor = getStatusColor(item.statusId);

    return (
      <ListItem
        ref={(node) => dragRef(dropRef(node))}
        style={{
          opacity: isDragging ? 0.5 : 1,
          cursor: (stateRoute === 7 || stateRoute === "5" || canView("TRANSACCIONES/RUTAS/PUNTOS DE ENTREGA", "update") === false) ? 'not-allowed' : 'move',
          // cursor: 'move',
          border: '1px solid lightgray',
          borderRadius: '4px',
          marginBottom: '8px',
          backgroundColor: 'white',
          transition: 'background-color 0.3s',
          '&:hover': {
            backgroundColor: '#f0f0f0',
          },
        }}
      >
        <DragIndicator sx={{ marginRight: 1 }} />
        <ListItemText 
          primary={
            <>
              {item.deliveryName} &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
              <Chip 
                label={`${new Date(item.deliveryDate).toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' })} ${new Intl.DateTimeFormat('en-CA', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'America/Mexico_City' }).format(new Date(item.deliveryDate))}`} 
                style={{ backgroundColor: '#E0F7FA', color: '#blue' }} 
              /> 
              {(item.statusId === 3 || item.statusId === 4) && (
                <> 
                  &nbsp;&nbsp;&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;&nbsp;
                  <Chip 
                    label={statusLabel}
                    color={statusColor} 
                  /> 
                  &nbsp;&nbsp;&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;&nbsp;
                  <Chip 
                    label={`${new Date(item.deliveryRealDate).toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' })} ${new Intl.DateTimeFormat('en-CA', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'America/Mexico_City' }).format(new Date(item.deliveryRealDate))}`}
                    color={statusColor} 
                    /> 
                </>
              )}
            </>
          }
        />
        <IconButton edge="end" aria-label="editImage" onClick={() => {
          if (canView("TRANSACCIONES/RUTAS/PUNTOS DE ENTREGA/ADJUNTOS", "watch")) {
            onEditImage(item)
          } else {
            setAlert({
              open: true,
              title: "Permiso Denegado.",
              subtitle: (<ul> • No tienes permiso para ver los archivos del punto de entrega.</ul>),
              type: "error",
              btn: __(`${module}.actions.close`),
              func: closeAlert
            })
          }
        }} disabled={item.statusId === 3 || item.statusId === 4}>
          <ImageIcon sx={{ color: item.statusId === 3 || item.statusId === 4 ?  'grey' : 'blue' }} />
        </IconButton>
        <IconButton edge="end" aria-label="editTime" onClick={() => {
          if (canView("TRANSACCIONES/RUTAS/PUNTOS DE ENTREGA/FECHA", "update")) {
            onEditTime(item)
          } else {
            setAlert({
              open: true,
              title: "Permiso Denegado.",
              subtitle: (<ul> • No tienes permiso para actualizar la fecha/hora del punto de entrega.</ul>),
              type: "error",
              btn: __(`${module}.actions.close`),
              func: closeAlert
            })
          }
        }} disabled={item.statusId === 3 || item.statusId === 4}>
          <AccessTime sx={{ color: item.statusId === 3 || item.statusId === 4 ?  'grey' : 'blue' }} />
        </IconButton>
        <IconButton edge="end" aria-label="editStatus" onClick={() => {
          if (canView("TRANSACCIONES/RUTAS/PUNTOS DE ENTREGA/ESTADO", "update")) {
            onEditStatus(item)
          } else {
            setAlert({
              open: true,
              title: "Permiso Denegado.",
              subtitle: (<ul> • No tienes permiso para actualizar el estado del punto de entrega.</ul>),
              type: "error",
              btn: __(`${module}.actions.close`),
              func: closeAlert
            })
          }
        }} disabled={item.statusId === 3 || item.statusId === 4}>
          <Edit sx={{ color: item.statusId === 3 || item.statusId === 4 ?  'grey' : 'blue' }} />
        </IconButton>
        <IconButton edge="end" aria-label="delete"
          onClick={() => {
            if (canView("TRANSACCIONES/RUTAS/PUNTOS DE ENTREGA", "delete")) {
              onDelete(item.idDeliveryPoint)
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para eliminar el punto de entrega.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
          }} disabled={!item.canDelete || item.statusId === 3 || item.statusId === 4} // Deshabilitar si canDelete es false
          sx={{
            color: item.canDelete ? 'red' : 'grey', // Cambiar color a rojo si está habilitado
          }}
        >
          <DeleteIcon />
        </IconButton>
      </ListItem>
    );
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <Card variant="outlined" style={{ width: 'auto', margin: 'auto', padding: '16px' }}>
        <CardContent>
          <Typography component="h4" variant="h4">{text}</Typography>

          <List>
            {deliveryPoints.map((point, index) => (
              <DraggableItem key={point.id} item={point} index={index} onDelete={handleDelete} />
            ))}
          </List>
        </CardContent>
        <Alert
            title={get(alert, "title")}
            subtitle={get(alert, "subtitle")}
            btn1={{ func: get(alert, "func") }}
            btn2={{}}
            type={get(alert, "type")}
            openAlert={get(alert, "open")}
            closeAlert={closeAlert}
        />
      </Card>
    </DndProvider>
  );
};

export default DragAndDropComponent;
